var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "render-money" }, [
    _vm._v("\n  " + _vm._s(_vm.format()) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }